unit Unit2;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Grids, WEBLib.Controls,
  WEBLib.ExtCtrls, WEBLib.CDS, Vcl.Graphics, WEBLib.Buttons,
  Vcl.Imaging.pngimage, Vcl.Imaging.jpeg;

type
  TForm2 = class(TForm)
    WebLabel26: TLabel;
    WebLabel7: TLabel;
    WebLabel13: TLabel;
    WebLabel14: TLabel;
    WebComboBox2: TComboBox;
    WebComboBox1: TComboBox;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    Urlop: TImageControl;
    WebCheckBox1: TCheckBox;
    WebCheckBox3: TCheckBox;
    WebEdit6: TEdit;
    WebEdit7: TEdit;
    WebLabel3: TLabel;
    Opis: TImageControl;
    WebLabel4: TLabel;
    WebLabel6: TLabel;
    procedure WebComboBox1Click(Sender: TObject);
    procedure WebComboBox2Click(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  Form2: TForm2;

implementation

{$R *.dfm}

uses ufrmMain, Unit1;

procedure TForm2.WebComboBox1Click(Sender: TObject);
var   ILO, ILO_P        : Real;
      PO, PO_P, TAK     : Integer;
begin
TAK:=0;
PO_P:=WebComboBox1.ItemIndex;
ILO_P:=StrtoFloat(WebEdit6.Text);
ILO:=0;
RAZ:=StrtoFloat(FrmMain.WebEdit5.Text);
URO:=StrtoFloat(FrmMain.WebEdit3.Text);
PO:=WebComboBox1.ItemIndex;
case PO of
0: ILO:=18.12;
1: ILO:=6.62;
2: ILO:=3.62;
3: ILO:=2.08;
4: ILO:=0.91;
5: ILO:=0.27;
6: ILO:=0;
end;
URO:=URO+ILO;
RAZ:=RAZ+ILO;
if WebCheckBox1.Checked=true then RAZ:=RAZ-ILO_P;
if WebCheckBox1.Checked=true then URO:=URO-ILO_P;
FrmMain.WebEdit5.Text:=FloattoStr(RAZ);
FrmMain.WebEdit3.Text:=FloattoStr(URO);
WebEdit6.Text:=FloattoStr(ILO);
WebCheckBox1.Checked:=true;
WebComboBox1.Color:=clMoneyGreen;
if WebCheckBox1.Checked=true then TAK:=Tak+1;
if WebCheckBox3.Checked=true then TAK:=Tak+1;
if TAK=2 then  FrmMain.WebEdit13.Text:='1';
end;

procedure TForm2.WebComboBox2Click(Sender: TObject);
var   ILO, ILO_P   : Real;
      PO, PO_P, TAK     : Integer;
begin
TAK:=0;
PO_P:=WebComboBox2.ItemIndex;
ILO_P:=StrtoFloat(WebEdit7.Text);
ILO:=0;
RAZ:=StrtoFloat(FrmMain.WebEdit5.Text);
URO:=StrtoFloat(FrmMain.WebEdit3.Text);
PO:=WebComboBox2.ItemIndex;
case PO of
0: ILO:=2.38;
1: ILO:=1.19;
2: ILO:=0.6;
3: ILO:=0.24;
4: ILO:=0;
end;
URO:=URO+ILO;
RAZ:=RAZ+ILO;
if WebCheckBox3.Checked=true then RAZ:=RAZ-ILO_P;
if WebCheckBox3.Checked=true then URO:=URO-ILO_P;
FrmMain.WebEdit5.Text:=FloattoStr(RAZ);
FrmMain.WebEdit3.Text:=FloattoStr(URO);
WebEdit7.Text:=FloattoStr(ILO);
WebCheckBox3.Checked:=true;
WebComboBox2.Color:=clMoneyGreen;
if WebCheckBox1.Checked=true then TAK:=Tak+1;
if WebCheckBox3.Checked=true then TAK:=Tak+1;
if TAK=2 then  FrmMain.WebEdit13.Text:='1';
end;
procedure TForm2.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLabel26 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebLabel13 := TLabel.Create(Self);
  WebLabel14 := TLabel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  Urlop := TImageControl.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  Opis := TImageControl.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebCheckBox1 := TCheckBox.Create(Self);
  WebCheckBox3 := TCheckBox.Create(Self);
  WebComboBox2 := TComboBox.Create(Self);
  WebComboBox1 := TComboBox.Create(Self);
  WebEdit6 := TEdit.Create(Self);
  WebEdit7 := TEdit.Create(Self);

  WebLabel26.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebLabel14.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  Urlop.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  Opis.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebCheckBox1.BeforeLoadDFMValues;
  WebCheckBox3.BeforeLoadDFMValues;
  WebComboBox2.BeforeLoadDFMValues;
  WebComboBox1.BeforeLoadDFMValues;
  WebEdit6.BeforeLoadDFMValues;
  WebEdit7.BeforeLoadDFMValues;
  try
    Name := 'Form2';
    Width := 701;
    Height := 465;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    WebLabel26.SetParentComponent(Self);
    WebLabel26.Name := 'WebLabel26';
    WebLabel26.Left := 8;
    WebLabel26.Top := 59;
    WebLabel26.Width := 64;
    WebLabel26.Height := 18;
    WebLabel26.Caption := 'Wakacje';
    WebLabel26.Font.Charset := DEFAULT_CHARSET;
    WebLabel26.Font.Color := clMenuHighlight;
    WebLabel26.Font.Height := -15;
    WebLabel26.Font.Name := 'Tahoma';
    WebLabel26.Font.Style := [fsBold];
    WebLabel26.HeightPercent := 100.000000000000000000;
    WebLabel26.ParentFont := False;
    WebLabel26.WidthPercent := 100.000000000000000000;
    WebLabel7.SetParentComponent(Self);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 8;
    WebLabel7.Top := 444;
    WebLabel7.Width := 211;
    WebLabel7.Height := 13;
    WebLabel7.Caption := 'Kalkulator fotowoltaiczny - Pro-Sun (c) 2022';
    WebLabel7.Color := clYellow;
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.Transparent := False;
    WebLabel7.WidthPercent := 100.000000000000000000;
    WebLabel13.SetParentComponent(Self);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 9;
    WebLabel13.Top := 89;
    WebLabel13.Width := 250;
    WebLabel13.Height := 13;
    WebLabel13.Caption := 'Ile godzin rocznie podr'#243#380'owa'#322'e'#347' '#347'rednio samolotem?';
    WebLabel13.HeightPercent := 100.000000000000000000;
    WebLabel13.WidthPercent := 100.000000000000000000;
    WebLabel14.SetParentComponent(Self);
    WebLabel14.Name := 'WebLabel14';
    WebLabel14.Left := 9;
    WebLabel14.Top := 131;
    WebLabel14.Width := 206;
    WebLabel14.Height := 13;
    WebLabel14.Caption := 'Ile dni sp'#281'dzi'#322'e'#347' '#347'rednio na rejsie statkiem?';
    WebLabel14.HeightPercent := 100.000000000000000000;
    WebLabel14.WidthPercent := 100.000000000000000000;
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 8;
    WebLabel1.Top := 103;
    WebLabel1.Width := 136;
    WebLabel1.Height := 13;
    WebLabel1.Caption := '(w ci'#261'gu ostatnich pi'#281'ciu lat)';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(Self);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 9;
    WebLabel2.Top := 146;
    WebLabel2.Width := 136;
    WebLabel2.Height := 13;
    WebLabel2.Caption := '(w ci'#261'gu ostatnich pi'#281'ciu lat)';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    Urlop.SetParentComponent(Self);
    Urlop.Name := 'Urlop';
    Urlop.Left := 344;
    Urlop.Top := 266;
    Urlop.Width := 344;
    Urlop.Height := 170;
    Urlop.HeightPercent := 100.000000000000000000;
    Urlop.WidthPercent := 100.000000000000000000;
    Urlop.ChildOrder := 20;
    Urlop.Picture.LoadFromFile('Unit2.Urlop.Picture.jpg');
    WebLabel3.SetParentComponent(Self);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 2;
    WebLabel3.Top := 330;
    WebLabel3.Width := 188;
    WebLabel3.Height := 13;
    WebLabel3.Caption := 'Prosz'#281' odpowiedzie'#263' na ka'#380'de pytanie.';
    WebLabel3.Font.Charset := DEFAULT_CHARSET;
    WebLabel3.Font.Color := clBlue;
    WebLabel3.Font.Height := -11;
    WebLabel3.Font.Name := 'Tahoma';
    WebLabel3.Font.Style := [];
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.ParentFont := False;
    WebLabel3.WidthPercent := 100.000000000000000000;
    Opis.SetParentComponent(Self);
    Opis.Name := 'Opis';
    Opis.Left := 103;
    Opis.Top := 349;
    Opis.Width := 137;
    Opis.Height := 57;
    Opis.HeightPercent := 100.000000000000000000;
    Opis.WidthPercent := 100.000000000000000000;
    Opis.ChildOrder := 3;
    Opis.Picture.LoadFromFile('Unit2.Opis.Picture.png');
    WebLabel4.SetParentComponent(Self);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 2;
    WebLabel4.Top := 411;
    WebLabel4.Width := 246;
    WebLabel4.Height := 13;
    WebLabel4.Caption := 'Zielone pod'#347'wietlenie oznacza udzielon'#261' odpowied'#378;
    WebLabel4.Font.Charset := DEFAULT_CHARSET;
    WebLabel4.Font.Color := clBlue;
    WebLabel4.Font.Height := -11;
    WebLabel4.Font.Name := 'Tahoma';
    WebLabel4.Font.Style := [];
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.ParentFont := False;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel6.SetParentComponent(Self);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 538;
    WebLabel6.Top := 439;
    WebLabel6.Width := 150;
    WebLabel6.Height := 16;
    WebLabel6.Caption := 'Kontakt: biuro@pro-sun.pl';
    WebLabel6.Font.Charset := DEFAULT_CHARSET;
    WebLabel6.Font.Color := clBlue;
    WebLabel6.Font.Height := -13;
    WebLabel6.Font.Name := 'Tahoma';
    WebLabel6.Font.Style := [];
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.ParentFont := False;
    WebLabel6.WidthPercent := 100.000000000000000000;
    WebCheckBox1.SetParentComponent(Self);
    WebCheckBox1.Name := 'WebCheckBox1';
    WebCheckBox1.Left := 299;
    WebCheckBox1.Top := 92;
    WebCheckBox1.Width := 113;
    WebCheckBox1.Height := 22;
    WebCheckBox1.ChildOrder := 21;
    WebCheckBox1.Color := clNone;
    WebCheckBox1.HeightPercent := 100.000000000000000000;
    WebCheckBox1.State := cbUnchecked;
    WebCheckBox1.Visible := False;
    WebCheckBox1.WidthPercent := 100.000000000000000000;
    WebCheckBox3.SetParentComponent(Self);
    WebCheckBox3.Name := 'WebCheckBox3';
    WebCheckBox3.Left := 299;
    WebCheckBox3.Top := 134;
    WebCheckBox3.Width := 113;
    WebCheckBox3.Height := 22;
    WebCheckBox3.ChildOrder := 21;
    WebCheckBox3.Color := clNone;
    WebCheckBox3.HeightPercent := 100.000000000000000000;
    WebCheckBox3.State := cbUnchecked;
    WebCheckBox3.Visible := False;
    WebCheckBox3.WidthPercent := 100.000000000000000000;
    WebComboBox2.SetParentComponent(Self);
    WebComboBox2.Name := 'WebComboBox2';
    WebComboBox2.Left := 314;
    WebComboBox2.Top := 134;
    WebComboBox2.Width := 374;
    WebComboBox2.Height := 21;
    WebComboBox2.HeightPercent := 100.000000000000000000;
    WebComboBox2.Text := 'Ponad dwa tygodnie';
    WebComboBox2.WidthPercent := 100.000000000000000000;
    SetEvent(WebComboBox2, Self, 'OnClick', 'WebComboBox2Click');
    WebComboBox2.ItemIndex := 0;
    WebComboBox2.Items.BeginUpdate;
    try
      WebComboBox2.Items.Clear;
      WebComboBox2.Items.Add('Ponad dwa tygodnie');
      WebComboBox2.Items.Add('1 - 2 tygodnie');
      WebComboBox2.Items.Add('4 - 6 dni');
      WebComboBox2.Items.Add('1 - 3 dni');
      WebComboBox2.Items.Add('Nie by'#322'em na rejsie od kilku lat');
    finally
      WebComboBox2.Items.EndUpdate;
    end;
    WebComboBox1.SetParentComponent(Self);
    WebComboBox1.Name := 'WebComboBox1';
    WebComboBox1.Left := 314;
    WebComboBox1.Top := 92;
    WebComboBox1.Width := 374;
    WebComboBox1.Height := 21;
    WebComboBox1.HeightPercent := 100.000000000000000000;
    WebComboBox1.Text := #321#261'cznie ponad 50 godzin';
    WebComboBox1.WidthPercent := 100.000000000000000000;
    SetEvent(WebComboBox1, Self, 'OnClick', 'WebComboBox1Click');
    WebComboBox1.ItemIndex := 0;
    WebComboBox1.Items.BeginUpdate;
    try
      WebComboBox1.Items.Clear;
      WebComboBox1.Items.Add(#321#261'cznie ponad 50 godzin');
      WebComboBox1.Items.Add(#321#261'cznie 25-50 godzin');
      WebComboBox1.Items.Add(#321#261'cznie 15-25 godzin');
      WebComboBox1.Items.Add(#321#261'cznie 8-15 godzin');
      WebComboBox1.Items.Add(#321#261'cznie 2 - 8 godzin');
      WebComboBox1.Items.Add(#321#261'cznie mniej ni'#380' 2 godziny');
      WebComboBox1.Items.Add('Nie latam od kilku lat.');
    finally
      WebComboBox1.Items.EndUpdate;
    end;
    WebEdit6.SetParentComponent(Self);
    WebEdit6.Name := 'WebEdit6';
    WebEdit6.Left := 257;
    WebEdit6.Top := 92;
    WebEdit6.Width := 38;
    WebEdit6.Height := 22;
    WebEdit6.ChildOrder := 30;
    WebEdit6.HeightPercent := 100.000000000000000000;
    WebEdit6.Text := '0';
    WebEdit6.Visible := False;
    WebEdit6.WidthPercent := 100.000000000000000000;
    WebEdit7.SetParentComponent(Self);
    WebEdit7.Name := 'WebEdit7';
    WebEdit7.Left := 257;
    WebEdit7.Top := 134;
    WebEdit7.Width := 38;
    WebEdit7.Height := 22;
    WebEdit7.ChildOrder := 30;
    WebEdit7.HeightPercent := 100.000000000000000000;
    WebEdit7.Text := '0';
    WebEdit7.Visible := False;
    WebEdit7.WidthPercent := 100.000000000000000000;
  finally
    WebLabel26.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebLabel14.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    Urlop.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    Opis.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebCheckBox1.AfterLoadDFMValues;
    WebCheckBox3.AfterLoadDFMValues;
    WebComboBox2.AfterLoadDFMValues;
    WebComboBox1.AfterLoadDFMValues;
    WebEdit6.AfterLoadDFMValues;
    WebEdit7.AfterLoadDFMValues;
  end;
end;

end.
